// Local translations — no context available at this level
export const T = {
  en_GB: {
    somethingWentWrong: "Something went wrong",
    unexpectedError: "An unexpected error occurred. Please try again.",
    tryAgain: "Try again",
    refreshPage: "Refresh page",
  },
  nb_NO: {
    somethingWentWrong: "Noe gikk galt",
    unexpectedError: "En uventet feil oppstod. Vennligst prøv igjen.",
    tryAgain: "Prøv igjen",
    refreshPage: "Oppdater siden",
  },
} as const;
